export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REFRESH = 'REFRESH'
